// Sidebar action types
export const SIDEBAR_OPEN = 'SIDEBAR_OPEN';
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE';
export const TOGGLE_TRAILHEADS_TRIPS = 'TOGGLE_TRAILHEADS_TRIPS';

// Legend action types
export const LEGEND_OPEN = 'LEGEND_OPEN';
export const LEGEND_CLOSE = 'LEGEND_CLOSE';
export const TOGGLE_LEGEND = 'TOGGLE_LEGEND';

// Wordpress JSON API action types
export const WP_JSON_API_REQUEST = 'WP_JSON_API_REQUEST';
export const WP_JSON_API_SUCCESS = 'WP_JSON_API_SUCCESS';
export const WP_JSON_API_ERROR = 'WP_JSON_API_ERROR';

// Trailhead / Trip selection action types
export const SELECT_TRIP_OR_TRAILHEAD = 'SELECT_TRIP_OR_TRAILHEAD';
export const DESELECT_TRIP_OR_TRAILHEAD = 'DESELECT_TRIP_OR_TRAILHEAD';

// Tracking distance measurement using Leaflet.draw
export const ENABLE_DISTANCE_READOUT = 'ENABLE_DISTANCE_READOUT';
export const DISABLE_DISTANCE_READOUT = 'DISABLE_DISTANCE_READOUT';



// WEBPACK FOOTER //
// ./map/common/actionTypes.js